import IndexManager from "../index-manager";
import debuggingProps from "./index.debug";
import { handlePreview } from "./index.preview";

(async function() {

  /* ***************** */
  /*     Settings      */
  /* ***************** */

  const manager = new IndexManager('ef', {
    // Exclusive Params
    'ef_theme': 'default',
    'ef_font': 'default',
    'ef_data_count': 10,
    'ef_initial_data': true,
    'ef_v_align': 'top',
    'ef_h_align': 'left',
    'ef_time_ampm': true, 
    'ef_quantity_type': 'unit',
    'ef_show_message': true,
    'ef_auto_hide': false,
    'ef_auto_hide_timeout': 60,

    // Colors: Retro
    'ef_1_clr1': '#fbfbfb',
    'ef_1_clr2': '#be1e2d',
    'ef_1_clr3': '#000',
    'ef_1_clr4': '#000',
    'ef_1_clr5': '#949494',
    'ef_1_clr6': '#262522',

    // Colors: Default
    'ef_2_clr1': '#fbfbfb',
    'ef_2_clr2': '#be1e2d',
    'ef_2_clr3': '#000',
    'ef_2_clr4': '#000',
    'ef_2_clr5': '#949494',
    'ef_2_clr6': '#be1e2d',

    // Colors: Transitional
    'ef_3_clr1': '#fbfbfb',
    'ef_3_clr2': '#000',
    'ef_3_clr3': '#FBD758',
    'ef_3_clr4': '#000',
    'ef_3_clr5': '#ffc1db',
    'ef_3_clr6': '#000',
    'ef_3_clr7': '#000',
    'ef_3_clr8': '#000',
    'ef_3_clr9': '#ffdd77',
  });

  /* ***************** */
  /*  Widget Behavior  */
  /* ***************** */
 
  class TrWidget {

    data = {};
    setting = {};
    theme = '';

    eventListLimit = 20;
    eventListItemCount = 0;

    isShowList = true;
    hideTimeout = null;

    setup(themeSetting, themeProps) {
      this.setting = themeSetting;
      this.theme = themeProps[this.setting['ef_theme']];
      this.theme.setup(this.setting);
      this.applyStyle();
    }

    /* Styling */

    applyStyle() {
      // Set Styles
      const styles = this.theme.styles();
      for (let i = 0; i < styles.length; i++) {
        const style = styles[i];
        h.setThemeVar(style.var, this.setting[style.key] || style.default);
      }
      // Set Fonts
      const reqFont = this.setting['ef_font'] || 'default';
      h.setThemeVar(
        this.theme.font().var,
        reqFont === 'default' ? this.theme.font().default : "'" + reqFont + "'"
      );

      this.theme.setVerticalAlign();
      this.theme.setHorizontalAlign();
    }

    /* Animation Logic */

    reset(data) {
      this.data = data;
    }

    createItem(emptyState = false, data = {}) {
      let el = document.createElement('div');
      // el.classList.add('transition-opacity');
      if(emptyState) {
        el.innerHTML = this.theme.htmlTemplateWhenEmpty(data).trim();
      } else {
        el.innerHTML = this.theme.html().trim();
      }

      return el.firstElementChild;
    }

    addItem(el) {
      if (!this.isShowList) {
        this.turnOffAutoHide()
      }

      this.theme.pushEventItem(el);
      this.eventListItemCount++;

      // Remove item if list item is reaching limit
      if (this.eventListItemCount >= this.eventListLimit) {
        this.theme.popEventItem();
        this.eventListItemCount--;
      }
    }

    setAnimationData(el) {
      if (!this.theme) return;
      if (!this.setting) {
        console.debug('Applied setting not found');
        return;
      }

      this.theme.setData(el, this.data);
    }

    async showAnimation(el) {
      if (!this.theme) return;
      if (!this.setting) {
        console.debug('Applied setting not found');
        return;
      }

      this.addItem(el);
    }

    toggleVisibility(isVisible) {
      if (isVisible) {
        this.theme.showList();
        this.isShowList = true
      } else {
        this.theme.hideList();
        this.isShowList = false;
      }
    }

    async turnOffAutoHide() {
      this.toggleVisibility(true);
    }

    async turnOnAutoHide() {
      if (!h.isTrue(this.setting['static'])) { // Hide mechanism not run if widget in static mode
        if (h.isTrue(this.setting['ef_auto_hide'])) {
          // Clear the previous timeout if it exists
          if (this.hideTimeout) {
            clearTimeout(this.hideTimeout);
          }
          let self = this;
          this.hideTimeout = setTimeout( function() {
            self.toggleVisibility(false);
          }, this.setting['ef_auto_hide_timeout'] * 1000);
        }
      }
    }
  }

  /* ***************** */
  /*   Widget Manager  */
  /* ***************** */

  IndexManager.prototype.addEventFeed = async function(data) {
    this.widget.reset(data);
    const elEvenFeedItem = this.widget.createItem();
    this.widget.setAnimationData(elEvenFeedItem);
    await this.widget.showAnimation(elEvenFeedItem);

    // hide list event in some duration
    this.widget.turnOnAutoHide()
  }

  IndexManager.prototype.addEventFeedEmpty = async function(url) {
    let data = {url: url}
    let elEvenFeedItemEmpty = this.widget.createItem(true, data);
    this.widget.showAnimation(elEvenFeedItemEmpty);

    // hide list event in some duration
    this.widget.turnOnAutoHide()
  }

  IndexManager.prototype.getShowMessage = function() {
    return (String(this.widget.setting.ef_show_message).toLowerCase() === 'true')
  }

  /* ***************** */
  /*      API Call     */
  /* ***************** */

  // Get data dari table tips_success_last_90_days jika pilihan data event feed history dengan API GET. Contoh: app/Containers/Frontend/UI/API/Routes/GetTopSupporter.v2.public.php 
  IndexManager.prototype.loadData = async function() {
    superagent
      .get(this.apiUrl(`stream/${this.key}/latest-tips`))
      .query({ limit: this.get('ef_data_count') })
      .accept('application/json')
      .end((err, res) => {
        try {
          var data = res.body.latestTip;
          let timeAMPM = this.get('ef_time_ampm', 'true');

          if (h.isTrue(this.get('ef_initial_data'))) {
            if (data.length == 0) {
              this.addEventFeedEmpty(res.body.pageUrl);
            } 
            else {
              data.forEach(async item => {
                await this.addEventFeed({
                  time: h.formatedTimeStamp(item.created_at.date, timeAMPM),
                  supporter_name: item.display_name,
                  quantity: item.quantity,
                  price: item.price,
                  unit: res.body.unitName,
                  supporter_message: (item.support_message) ? '"' + item.support_message + '"' : "" ,
                });
              });
            }
          } else {
            this.addEventFeedEmpty(res.body.pageUrl); // for handling empty state when creator choose initial data false
          }
        } catch (err) {
          // console.log(err);
        }
      });
  }

  /* ***************** */
  /*     Websocket     */
  /* ***************** */

  function setupListener() {
    manager.addListenerOn('new-tip', function(data) {
      manager.addEventFeed(data);
    });
    manager.addListenerOn('new-tip-simulation', function(data) {
      manager.addEventFeed(data);
    });
  }

  /* ***************** */
  /*       Init        */
  /* ***************** */

  await manager.init({
    widget: new TrWidget(),
    debug: debuggingProps,
    preview: handlePreview
  });
  
  setupListener();
})();
